module.exports = __webpack_public_path__ + "img/150h100_s_fortochkoy_50h50_v_nizhney_chasti_seredina_nizhney_chasti_.d0f6e613.svg";